import React from 'react'
import { createRoot } from 'react-dom/client'
import StudentRequestWizard from '../components/StudentRequestWizard'

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('student-request-wizard')
  if (!container) return

  const config = JSON.parse(container.dataset.config)

  const root = createRoot(container)
  root.render(<StudentRequestWizard config={config} />)
})
